import { render, staticRenderFns } from "./BusinessPrograms.vue?vue&type=template&id=003c8e50"
import script from "./BusinessPrograms.vue?vue&type=script&lang=js"
export * from "./BusinessPrograms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports